import React, { Component, Fragment } from "react";
import CollapseMenu from "../../../../config/atoms/CollapseMenu";
import MenuDetail from "../MenuDetail";
import swal from 'sweetalert';
import { dataMahasiswa } from '../../../../dummy-data/mahasiswa';
import { dataKRS } from '../../../../dummy-data/krs-khs';
const $ = require("jquery");
$.Datatable = require("datatables.net");

// Dummy mata kuliah untuk pilihan pengajuan
const dummyMataKuliah = [
    { mk_id: 37, kode_mk: "TI705", nama_mk: "Internet of Things", sks_teori: 2, sks_praktek: 1, semester: 7 },
    { mk_id: 38, kode_mk: "TI706", nama_mk: "Natural Language Processing", sks_teori: 2, sks_praktek: 1, semester: 7 },
    { mk_id: 39, kode_mk: "TI707", nama_mk: "Computer Vision", sks_teori: 2, sks_praktek: 1, semester: 7 },
    { mk_id: 40, kode_mk: "TI708", nama_mk: "Sistem Terdistribusi", sks_teori: 3, sks_praktek: 0, semester: 7 },
    { mk_id: 41, kode_mk: "TI709", nama_mk: "DevOps", sks_teori: 2, sks_praktek: 1, semester: 7 },
];

const statusKrs = {
    setujui: 'setujui',
    pengajuan: 'pengajuan',
    tolak: 'tolak',
    hapus: 'hapus'
}

class PengajuanKrs extends Component {

    state = {
        matkul: {
            listMatkul: [],
            batas_sks: '',
            ipslalu: ''
        },
        check_list: [],
        pengajuan: {
            listPengajuan: [],
            sks_semesterini: ''
        },
        iddetpeng: [],
        isLoading: false,
        isPengajuan: false
    }

    getAllData = () => {
        $('.cekKRS').prop("checked", false);
        $('.cekMK').prop("checked", false);
        const { nim, semester } = this.props.location.state;

        // Get KRS data for this student
        const krsData = dataKRS.filter(k => k.nim === nim && k.semester_ke === parseInt(semester));
        const listPengajuan = krsData.map(k => ({
            idkrs: k.krs_id,
            kodemk: k.kode_mk,
            namamk: k.nama_mk,
            sksteori: k.sks || 3,
            skspraktek: 0,
            statuskrs: 'Disetujui',
            bu: 'B',
            statusbayar: 'Sudah Bayar'
        }));

        // Get available mata kuliah that haven't been taken
        const takenCodes = krsData.map(k => k.kode_mk);
        const availableMK = dummyMataKuliah
            .filter(mk => !takenCodes.includes(mk.kode_mk))
            .map(mk => ({
                idmk: mk.mk_id,
                kodemk: mk.kode_mk,
                namamk: mk.nama_mk,
                sksteori: mk.sks_teori,
                skspraktek: mk.sks_praktek,
                semester: mk.semester,
                bu: 'B',
                sks_total: mk.sks_teori + mk.sks_praktek,
                mkpras: { prasarat_satu: null, prasarat_dua: null, prasarat_tiga: null }
            }));

        this.setState({
            matkul: {
                listMatkul: availableMK,
                batas_sks: 24,
                ipsLalu: 3.50
            },
            pengajuan: {
                listPengajuan: listPengajuan,
                sks_semesterini: krsData.reduce((sum, k) => sum + (k.sks || 3), 0)
            },
            check_list: [],
            iddetpeng: []
        });
    }

    toggleCheckbox = (event, selectedVal) => {
        const data = {
            idmk: selectedVal.idmk,
            bu: selectedVal.bu,
            sks_total: selectedVal.sks_total
        }

        if (event.target.checked) {
            this.state.check_list.push(data)
        } else {
            var index = this.state.check_list.findIndex(x => x.idmk === data.idmk);
            this.state.check_list.splice(index, 1);
        }
    }

    toggleCheckboxKRS = (event) => {
        if (event.target.checked) {
            this.state.iddetpeng.push(event.target.value)
        } else {
            var index = this.state.iddetpeng.indexOf(event.target.value);
            this.state.iddetpeng.splice(index, 1);
        }
    }

    setPengajuan = (type) => {
        if (this.state.iddetpeng.length === 0) {
            swal({ icon: 'warning', title: 'Peringatan', text: 'Pilih data terlebih dahulu!' });
        }
        else {
            this.setState({ isLoading: true });

            setTimeout(() => {
                swal({
                    icon: 'success',
                    title: 'Demo Mode',
                    text: `KRS berhasil di-${type} (simulasi)`,
                    timer: 1500,
                    buttons: false
                }).then(() => {
                    this.getAllData();
                    this.setState({ isLoading: false });
                });
            }, 300);
        }
    }

    ProcessPengajuan = () => {
        const { pengajuan, matkul } = this.state
        // total sks yang akan diajukan + total sks yang sudah diajukan
        const totalSksDiajukan = this.state.check_list.map(x => x.sks_total).reduce((a, b) => a + b, 0) + pengajuan.sks_semesterini

        if (this.state.check_list.length === 0) {
            swal({ icon: 'warning', title: 'Peringatan', text: 'Pilih mata kuliah terlebih dahulu!' });
        }
        else {
            this.setState({ isPengajuan: true });

            setTimeout(() => {
                swal({
                    icon: 'success',
                    title: 'Demo Mode',
                    text: 'Pengajuan KRS berhasil disimpan (simulasi)',
                    timer: 1500,
                    buttons: false
                }).then(() => {
                    this.getAllData();
                    this.setState({ isPengajuan: false });
                });
            }, 300);
        }
    }

    parserText = (val) => {
        var txt = document.createElement("textarea");
        txt.innerHTML = val;
        return txt.value;
    }

    componentDidMount = () => {
        this.getAllData();
        CollapseMenu();
        document.getElementById("krsMenu").classList.add("active");
    };

    render() {
        const { angkatan, jurusan, nama, nim, semester, ta } = this.props.location.state
        const { listMatkul, batas_sks, ipsLalu } = this.state.matkul
        const { listPengajuan } = this.state.pengajuan

        const statusTheme = (val) => {
            if (val === 'Disetujui') return 'success'
            else if (val === 'Ditolak') return 'danger'
            else if (val === 'Aktif') return 'info'
            else if (val === 'Konversi') return 'warning'
            else return 'primary'
        }

        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p
                                className="abu"
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    color: "#999999",
                                    textTransform: "capitalize",
                                }}
                            >
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;
                                Detail Pengajuan KRS
                            </p>
                        </div>
                        <div className="col-12 col-xl-4 sm-md-none">
                            <div className="justify-content-end d-flex ">
                                <div
                                    style={{ cursor: "pointer" }}
                                    title="expand/minimize"
                                    id="toogleMenu"
                                >
                                    <i className="fa fa-expand abu" id="iconQ"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="row" id="smoothMain">
                    <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                        <MenuDetail id={this.props.match.params.idMhs} nim={nim} />
                    </div>
                    <div className="col-xl-9" id="kontenKiri">
                        <div className="smooth mb-2">
                            {/* mata kuliah diajukan */}
                            <div className="card card-custom">
                                <div className="card-body">
                                    <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                        Pengajuan KRS
                                    </p>
                                    <div className="table-responsive pl-2 pr-2">
                                        <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td>NIM</td>
                                                    <td> : </td>
                                                    <td>{nim}</td>

                                                    <td>Angkatan</td>
                                                    <td> : </td>
                                                    <td>{angkatan}</td>
                                                </tr>
                                                <tr>
                                                    <td>Nama</td>
                                                    <td> : </td>
                                                    <td>{this.parserText(nama)}</td>

                                                    <td>Tahun Akademik</td>
                                                    <td> : </td>
                                                    <td>{ta}</td>
                                                </tr>
                                                <tr>
                                                    <td>Prodi</td>
                                                    <td> : </td>
                                                    <td>{jurusan}</td>
                                                    <td>Semester</td>
                                                    <td> : </td>
                                                    <td>{semester}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <br />
                                    <div className="table-responsive pl-2 pr-2 mt-3">
                                        <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                            <thead>
                                                <tr>
                                                    <th>
                                                        <div style={{ display: "flex" }}>
                                                            <span>
                                                                Pilih
                                                            </span>
                                                        </div>
                                                    </th>
                                                    <th>No</th>
                                                    <th>Kode MK</th>
                                                    <th>Mata Kuliah</th>
                                                    <th>SKS Teori</th>
                                                    <th>SKS Praktek</th>
                                                    <th>Status</th>
                                                    <th>B/U</th>
                                                    <th>Bayar</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    listPengajuan.length !== 0 ? listPengajuan.map((his, index) => {
                                                        return (
                                                            <tr key={index}>
                                                                <td>
                                                                    <input
                                                                        onClick={this.toggleCheckboxKRS}
                                                                        type="checkbox"
                                                                        className="cekKRS"
                                                                        disabled={this.state.isLoading}
                                                                        value={his.idkrs}
                                                                    />
                                                                </td>
                                                                <td>{index + 1}</td>
                                                                <td>{his.kodemk}</td>
                                                                <td>{his.namamk}</td>
                                                                <td>{his.sksteori}</td>
                                                                <td>{his.skspraktek}</td>
                                                                <td><span className={`badge badge-${statusTheme(his.statuskrs)}`} style={{ fontSize: '14px' }}>{his.statuskrs}</span></td>
                                                                <td>{his.bu}</td>
                                                                <td>{his.statusbayar}</td>
                                                            </tr>
                                                        )
                                                    }) : <tr><td colSpan="9"><center>Belum mengajukan mata kuliah</center></td></tr>
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <p align="right" className="pl-2 pr-2">
                                        <button className="btn btn-success" onClick={() => this.setPengajuan(statusKrs.setujui)} disabled={this.state.isLoading}>
                                            setujui
                                        </button>
                                        &nbsp;&nbsp;&nbsp;
                                        <button className="btn btn-warning text-light" onClick={() => this.setPengajuan(statusKrs.tolak)} disabled={this.state.isLoading}>
                                            tolak
                                        </button>
                                        &nbsp;&nbsp;&nbsp;
                                        <button className="btn btn-danger" onClick={() => this.setPengajuan(statusKrs.hapus)} disabled={this.state.isLoading}>
                                            hapus
                                        </button>
                                        &nbsp;&nbsp;&nbsp;
                                        <button className="btn btn-primary" onClick={() => this.setPengajuan(statusKrs.pengajuan)} disabled={this.state.isLoading}>
                                            pengajuan
                                        </button>
                                    </p>
                                </div>
                            </div>
                            {/* end mata kuliah diajukan  */}

                            {/* pilihan mata kuliah  */}
                            <div className="card card-custom mt-3">
                                <div className="card-body">
                                    <p className="card-title pl-2 pr-2" style={{ fontSize: "16px", marginTop: "10px", marginBottom: "35px" }}>
                                        Pilihan Mata Kuliah Untuk diajukan
                                    </p>
                                    <div className="table-responsive pl-2 pr-2">
                                        <table
                                            className="display expandable-table tableBord table-striped"
                                            style={{ width: "100%" }}
                                        >
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td width="180px">IP Semester Lalu</td>
                                                    <td width="10px"> : </td>
                                                    <td width="260px">{ipsLalu}</td>
                                                    <td width="180px">Maksimal SKS semester ini</td>
                                                    <td width="10px"> : </td>
                                                    <td width="180px">{batas_sks}</td>
                                                </tr>
                                                <tr>
                                                    <td>Tahun Akademik</td>
                                                    <td> : </td>
                                                    <td>{ta}</td>
                                                    <td>Semester Saat Ini</td>
                                                    <td> : </td>
                                                    <td>{semester}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="pl-2 pr-2">
                                        <div className="table-responsive mt-3">
                                            <table
                                                id="MK"
                                                className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                                <thead>
                                                    <tr>
                                                        <th data-orderable="false">
                                                            <div style={{ display: "flex" }}>
                                                                <span>
                                                                    Pilih
                                                                </span>
                                                            </div>
                                                        </th>
                                                        <th data-orderable="false">Kode MK</th>
                                                        <th data-orderable="false">Mata Kuliah</th>
                                                        <th data-orderable="false">SKS Teori</th>
                                                        <th data-orderable="false">SKS Praktek</th>
                                                        <th>Semester</th>
                                                        <th data-orderable="false">B/U</th>
                                                        <th data-orderable="false">MK Prasyarat</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {
                                                        listMatkul.map((v, index) => {
                                                            return (
                                                                <tr key={index}>
                                                                    <td>
                                                                        <input
                                                                            type="checkbox"
                                                                            onChange={(e) => this.toggleCheckbox(e, v)}
                                                                            className="cekMK"
                                                                            disabled={this.state.isLoading}
                                                                        />
                                                                    </td>
                                                                    <td>{v.kodemk}</td>
                                                                    <td>{v.namamk}</td>
                                                                    <td>{v.sksteori}</td>
                                                                    <td>{v.skspraktek}</td>
                                                                    <td>{v.semester}</td>
                                                                    <td>{v.bu}</td>
                                                                    <td>
                                                                        <ul>
                                                                            {v.mkpras.prasarat_satu && <li>{v.mkpras.prasarat_satu}</li>}
                                                                            {v.mkpras.prasarat_dua && <li>{v.mkpras.prasarat_dua}</li>}
                                                                            {v.mkpras.prasarat_tiga && <li>{v.mkpras.prasarat_tiga}</li>}
                                                                        </ul>
                                                                    </td>
                                                                </tr>
                                                            )
                                                        })
                                                    }
                                                </tbody>
                                            </table>
                                        </div>
                                        <br />
                                        {
                                            listMatkul.length !== 0 ?
                                                <p align="right">
                                                    <button className="btn btn-success" id="btnPengajuan" onClick={this.ProcessPengajuan} disabled={this.state.isPengajuan}>
                                                        simpan
                                                    </button>
                                                </p> : null
                                        }
                                    </div>
                                </div>
                            </div>
                            {/* end pilihan mata kuliah */}
                        </div>
                    </div>
                </div>
            </Fragment>
        );
    }
}

export default PengajuanKrs;
